import { render, staticRenderFns } from "./LocationsSelector.vue?vue&type=template&id=2f4af54e"
import script from "./LocationsSelector.vue?vue&type=script&lang=js"
export * from "./LocationsSelector.vue?vue&type=script&lang=js"
import style0 from "./LocationsSelector.vue?vue&type=style&index=0&id=2f4af54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports